<script>
	
	import {API,SPINNER} from '../global.js'
	import {CLIENTE} from '../store.js'
	import ClienteCAM from './cliente-cam.svelte'
	import ClienteCEAR from './cliente-cear.svelte'
	import ClienteInfo from './cliente-info.svelte'
	import ClienteOper from './cliente-operaciones.svelte'
	import ClientePun from './cliente-puntos.svelte'
	import ClientePagos from '../pagos/pagos.svelte'
	import ClienteReservas from '../reservas/reservas.svelte'
	import Ventas from '../ventas/ventas.svelte'
	import Comprobantes from '../comprobantes/comprobantes.svelte'
	import Swal from 'sweetalert2'

	let cliente = ''
	let data = {}
	let data_socio_link = {}
	let vista = ''
	let page=0
	let loading = false
	let recientes = []
	let ver_recientes = false

	const menu_options = [
		{ title: 'Info',   component: ClienteInfo , activo:true },
		{ title: 'CAM',   component: ClienteCAM  , activo:true },
		{ title: 'CEAR',   component: ClienteCEAR  , activo:true },
		{ title: 'Operaciones',  component: ClienteOper , activo:true },
		{ title: 'Reservas',  component: ClienteReservas , activo:true },
		{ title: 'Puntos',  component: ClientePun , activo:true },
		{ title: 'PAGOS', component: ClientePagos, activo:true },
		{ title: 'Ventas', component: Ventas, activo:true },
		{ title: 'Comprobantes', component: Comprobantes, activo:false },
	];
	let menu = ''

	function submit(){
		ver_recientes = false
		if(parseInt(cliente)>0) {
			CLIENTE.set(parseInt(cliente))
			let historia = JSON.parse(localStorage.getItem('historia')||'[]')
			historia = [cliente,...historia]
			historia = [...new Set(historia)]
			historia = historia.slice(0,20)
			localStorage.setItem('historia',JSON.stringify(historia))
		}
		data = {}
		data_socio_link = {}
		vista = ''
		page=0
		menu = {}
		refresh()
	}

	async function refresh(){
		loading = true
		if(parseInt(cliente)>0){
			
			let rs = await fetch(`${API}/clientes-by-id/${cliente}`)
			let ds = await rs.json()
			if(ds.success && ds.count){
				data = { info: ds.data[0], contactos : ds.contactos, domicilios : ds.domicilios }
				menu = menu_options[1]
				vista = 'info'
			}
		}else if(cliente.length>0){
			let rs = await fetch(`${API}/clientes-by-pattern/${cliente.trim()}?rpp=10&p=${page}`)
			let ds = await rs.json()
			data= ds
			vista='lista'
		}
		loading = false
	}

	function setCliente(cli){
		cliente=cli
		submit()
	}

	function cambiarPagina(mov){
		page = page + mov
		refresh()
	}

	function onKeyPress(ev){
		if( ev.code === 'ArrowDown'){
			recientes = JSON.parse(localStorage.getItem('historia')||'[]')
			ver_recientes = true
		}
	}

	function handleKeydown(ev){
		if(ev.code === 'Escape'){
			if(ver_recientes) ver_recientes = false
			//else setCliente('')
		}
	}

	async function get_link(){
		let host = window.location.origin
		loading = true
		if(parseInt(cliente)>0){
			let rs = await fetch(`${API}/cliente-get-token/${cliente}`)
			let ds = await rs.json()
			if(ds.success){
				data_socio_link = ds.data
				let texto = `
${data_socio_link.email}

Estimado socio : 

	Ingresa a traves del siguiente enlace, para ver el estado de su cuenta corriente de la cuota anual de mantenimiento.

	${host}?m=cliente&c=${data_socio_link.usuario}&h=${data_socio_link.token}

	Cualquier duda puede contactar a su ejecutivo, ${data_socio_link.nomeje} ${data_socio_link.apeeje}, a su email : ${data_socio_link.emaileje}, o a su telefono (011) ${data_socio_link.telefono}.

`
			navigator.clipboard.writeText(texto);
			Swal.fire({
				  icon: 'success',
				  title: 'Datos copiados al portapapeles.',
				  showConfirmButton: false,
				  timer: 1000
				})
			}
		}else {
			Swal.fire({
			  icon: 'error',
			  title: 'Debe elegir el cliente.',
			  showConfirmButton: false,
			  timer: 1000
			})
		}
		loading = false
		
	}


	$: { 
		cliente = $CLIENTE 
		refresh()
	}

</script>

<svelte:window on:keydown={handleKeydown}/>

<form on:submit|preventDefault={submit}>
	<div class="row mb-2">
	  	<div class="col-auto">
			<div class="input-group mb-3">
				<input bind:value="{cliente}" type="text" class="form-control" 
					placeholder="cliente" aria-label="" 
					aria-describedby="basic-addon2"
					on:keydown={onKeyPress}>
				
				<span class="input-group-text" id="basic-addon2" on:click={submit}><i class="bi-search"></i></span>
				<span class="input-group-text" id="basic-addon3" on:click={()=>setCliente('')}><i class="bi-x-lg"></i></span>
			</div>
		</div>
		<div class="col-auto">
			<div class="my-2">
				<span class="" id="basic-addon4">{data?.info?.RazonSocial || ''}</span>
				{#if vista === 'info'}
					<span class="badge bg-dark mx-4" on:click={get_link}>Link socio!</span>
				{/if}
			</div>
		</div>
	</div>
	
	{#if ver_recientes}
		<div class="row historia text-center">
			<div class="col-12 mb-3 text-end">
				<i class="bi-x-lg text-danger is-hover" on:click={()=>ver_recientes=false}></i>
			</div>
			{#each recientes as item}
				<div class="col-12 py-1 pe-4 border-bottom is-hover" on:click="{()=>setCliente(item)}">{item}</div>
			{:else}
			<div class="col-12 py-1 pe-4 border">vacio</div>
			{/each}
		</div>
	{/if}
</form>


{#if vista==='info'}
	<ul class="nav nav-tabs">
		{#each menu_options as item, index}
	  		<li class="nav-item" on:click={()=>item.activo?menu=item:''}>
	  			<a class="nav-link" class:active={menu.title===item.title} class:disabled={!item.activo} class:fst-italic={!item.activo} aria-current="page" href={"#"}>{item.title}</a>
	  		</li>
		{/each}
	</ul>

<svelte:component this={menu.component} data={data}/>
{/if}

{#if vista==='lista'}
	<div class="card w-100">
		<div class="card-header">
			<div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Toolbar with button groups">
				<div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
				  <button type="button" class="btn btn-secondary btn-sm" disabled={page===0} on:click={()=>cambiarPagina(-page)}>&lt;&lt;</button>
				  <button type="button" class="btn btn-secondary btn-sm" disabled={page===0} on:click={()=>cambiarPagina(-1)}>&lt;</button>
				  <button type="button" class="btn btn-secondary btn-sm" disabled={data.eof} on:click={()=>cambiarPagina(1)}>&gt;</button>
				</div>
				<div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
				  <button type="button" class="btn btn-danger btn-sm" on:click={()=>setCliente('')}>&Cross;</button>
				</div>
			</div>
		</div>
		<div class="card-body">
			<table class="table table-hover table-sm">
				<thead>
				    <tr>
						<th scope="col">Cliente</th>
						<th scope="col">Nombre</th>
				    </tr>
				</thead>
				<tbody>
					{#each data.data as item, index}
						<tr>
							<th scope="row" on:click={()=>setCliente(item.IdCliente)}>{item.IdCliente}</th>
							<td>{item.RazonSocial}</td>
						</tr>
					{/each}
				</tbody>
			</table>
		</div>
	</div>
{/if}

{#if loading}
	{@html SPINNER}
{/if}


<style>
	.historia{
		width: 150px;
		position: absolute;
		top: 115px;
		left: 40px;
		border: solid 0	px red;
		border-radius: 3px;
		background-color: white;
		z-index:2000;
		border:solid 1px lightgray;
	}
</style>